// extracted by mini-css-extract-plugin
export var measureBox = "_9l-0";